/**
 * 公告
 */
import 'scss/component/announcement.scss'
import { cookie } from 'js/libs/utils-cookie'
var countDown = null
var ancmtModel = {
  addEvent: function () {
    $('.ancmt-detail').on('click', '.ancmt-bullet-box-close-btn', function () {
      $('.ancmt-wrap').hide()
    })
    $('body').not('.ancmt-wrap').bind('click', function () {
      $('.ancmt-wrap').hide()
    })
  },
  countDown: function () {
    var allTime = 15
    countDown = setInterval(function () {
      $('#abb_num').text(--allTime)
      if (allTime < 0) {
        $('.ancmt-wrap').hide()
        clearInterval(countDown)
      }
    }, 1000)
  },
  fireAction: function () {
    $('#open_announcement').bind('click', function (e) {
      e.stopPropagation()
      $('.ancmt-wrap').show()
    })
  },
  showTop: function () {
    if (!cookie.get('top_banner_closed')) {
      $('#top_banner_wrap').show()
    }
  },
  bindTopAction: function () {
    $('#close_banner_top').bind('click', function () {
      $('#top_banner_wrap').hide()
      var curDate = new Date()
      var curTamp = curDate.getTime()
      var curWeeHours = new Date(curDate.toLocaleDateString()).getTime() - 1
      var passedTamp = curTamp - curWeeHours
      var leftTamp = 24 * 60 * 60 * 1000 - passedTamp
      var leftTime = new Date()
      leftTime.setTime(leftTamp + curTamp)
      cookie.pureSet('top_banner_closed', true, leftTime.toGMTString() + ';path=/')
    })
  },
  init: function () {
    let that = this
    that.addEvent()
    that.fireAction()
    that.showTop()
    that.bindTopAction()
    // that.countDown()
  }
}
ancmtModel.init()



// WEBPACK FOOTER //
// ./src/js/libs/utils-announcement.js